export default "__VITE_ASSET__BKmcvO49__"